import settings from '@/config/settings';

import type {IUser, IUserShort, IUserUpdate} from '@/api/types/user';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

const url = new URL(settings.SERVICES.BACK.getUrl() + '/users');

export const userAPI = useAPIHook<IUserShort, IUser, unknown, IUserUpdate>(url);
